//--- React
import { useSelector } from "react-redux";
//--- Ant Design
import { Col, Divider, Row } from "antd";
//--- Project
import "./style.css";
import BRAKE_ICON from "assets/images/icons/energy_battery.svg";
import { UNITS } from "components/Common/Constants";

const EnergyAnalytics = () => {
  const tripSummary = useSelector((state) => state.testRide.tripSummary);

  const innerContent = (
    title,
    minTitle,
    minValue,
    maxTitle,
    maxValue,
    minUnit,
    maxUnit,
    minValueClassName
  ) => {
    return (
      <Row className="border pd1 h100">
        <Col span={24} className="text-center highlight-title">
          {title}
        </Col>
        <Col span={24} className="mt1 mb025">
          <Row justify={"space-evenly"}>
            <Col className="text-center">
              {minValue ? (
                <div>
                  <span className={"avg-count " + minValueClassName}>
                    {minValue}
                  </span>
                  <span className="card-sub-text ml015">{minUnit}</span>
                </div>
              ) : (
                <span className="disabled ml025">NA</span>
              )}
              <div className="card-sub-text text-center">{minTitle}</div>
            </Col>
            {maxTitle ? (
              <>
                <Col>
                  <Divider className="h100" type={"vertical"} />
                </Col>
                <Col className="text-center">
                  <div>
                    <span className="avg-count">{maxValue}</span>
                    <span className="card-sub-text ml015">
                      {maxUnit || minUnit}
                    </span>
                  </div>
                  <div className="card-sub-text">{maxTitle}</div>
                </Col>
              </>
            ) : null}
          </Row>
        </Col>
      </Row>
    );
  };

  return (
    <Row gutter={[16, 10]} className="highlight">
      <Col span={24}>
        <Row gutter={[16, 16]} align={"middle"} className="mt1">
          <Col className="align-center">
            <img src={BRAKE_ICON} alt="view" height={24} />
          </Col>
          <Col className="sub-title">Energy & Range</Col>
        </Row>
      </Col>
      <Col span={24}>
        <Row gutter={[16, 16]} className="h100">
          <Col xs={24} md={12} lg={6}>
            {innerContent(
              "Load Analysis",
              "",
              !tripSummary?.load || tripSummary?.load === "UNKNOWN"
                ? null
                : tripSummary.load?.charAt(0) +
                    tripSummary.load?.slice(1).toLowerCase(),
              null,
              null,
              null,
              null,
              tripSummary?.load?.toLowerCase() === "low"
                ? "red"
                : tripSummary?.load?.toLowerCase() === "high"
                ? "green"
                : ""
            )}
          </Col>
          <Col xs={24} md={12} lg={6}>
            {innerContent(
              "Energy",
              "",
              tripSummary?.energyPerKm,
              null,
              0,
              UNITS.WATT_HR_PER_KM
            )}
          </Col>
          <Col xs={24} md={12} lg={6}>
            {innerContent(
              "Range",
              null,
              tripSummary?.distancePerCharge,
              null,
              null,
              UNITS.KM
            )}
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
export default EnergyAnalytics;
